import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown";
import { useConfirm } from "@/context/confirm-context";
import { useDeleteOrgMember } from "@/queries/organization-members";
import { OrganizationMember } from "@/types/organization-member";
import { Trash2Icon } from "lucide-react";

interface DeleteMemberProps {
  organizationMember: OrganizationMember;
}

const DeleteMember = ({ organizationMember }: DeleteMemberProps) => {
  const { confirm } = useConfirm();
  const deleteOrganizationMember = useDeleteOrgMember();

  const handleClick = async () => {
    const isConfirmed = await confirm();
    if (isConfirmed) deleteOrganizationMember.mutate(organizationMember.id);
  };

  return (
    <DropdownMenuGroup>
      <DropdownMenuItem
        className="text-destructive focus:text-destructive"
        onClick={handleClick}
      >
        <Trash2Icon />
        Remove
      </DropdownMenuItem>
      <DropdownMenuSeparator />
    </DropdownMenuGroup>
  );
};

export default DeleteMember;
